import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/unterstatus/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="SubStatus"
      returnRoute="/auswahlfelder/subStatus"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const SubStatusRoute = Route;
